import { EfficiencyModel } from '../../types';
import { Nullable, Dictionary } from '../../../../global/types';
import { unique } from '../../../../utils/array/unique';
import { getPromiseResults } from '../../../../utils/promise/getPromiseResults';
import { mapToObject } from '../../../../utils/object';

export function getProductIdsWithoutUrl(model: EfficiencyModel): string[] {
  const results: string[] = [];
  if (!model.url) {
    results.push(model.id);
  }
  return unique(results);
}

export function setProductUrls(
  model: EfficiencyModel,
  urls: Dictionary<string>,
): EfficiencyModel {
  if (!model.url && urls[model.id]) {
    model.url = urls[model.id];
  }
  return model;
}

export async function setModelProductUrls(
  model: EfficiencyModel,
  getProductIdByUrl?: Nullable<(id: string) => Promise<string>>,
): Promise<EfficiencyModel> {
  if (typeof getProductIdByUrl === 'function') {
    const ids = getProductIdsWithoutUrl(model);
    const urls = await getPromiseResults(ids, getProductIdByUrl);
    model = setProductUrls(model, mapToObject(urls));
  }
  return model;
}
